// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { IntelRow, IntelUpsertParams } from "@suns/api/generated-client/apollo";
import { IntelFormSchema } from "./components/IntelForm";

export function intelResponseToFormData(intel: IntelRow): IntelFormSchema {
  return {
    id: intel.id,
    playerId: intel.players?.map((player) => player.id),
    teamId: intel.teams?.map((team) => team.id),
    agentId: intel.agents?.map((agent) => agent.id),
    personnelId: intel.personnel?.map((personnel) => personnel.id),
    level: intel.level,
    status: intel.status,
    authorUsername: intel.authorUsername,
    authorName: intel.authorName,
    notes: intel.notes,
    source: intel.source,
    trustworthiness: intel.trustworthiness,
    tags: intel.tags,
  };
}

export function intelFormDataToUpsertParams(
  intel: IntelFormSchema
): IntelUpsertParams {
  const { playerId, teamId, agentId, personnelId, ...restIntel } = intel;
  if (!playerId && !teamId && !agentId && !personnelId) {
    throw new Error(
      "Select at least one entity for the intel to be associated with."
    );
  }

  return {
    ...restIntel,
    playerIds: playerId?.filter((id): id is number => id !== undefined) ?? [],
    teamIds: teamId?.filter((id): id is number => id !== undefined) ?? [],
    agentIds: agentId?.filter((id): id is number => id !== undefined) ?? [],
    personnelIds:
      personnelId?.filter((id): id is number => id !== undefined) ?? [],
    id: intel.id || undefined,
    tags: intel.tags ?? undefined,
    level: intel.level ?? undefined,
  };
}
